module.exports = __webpack_public_path__ + "static/media/fig_6b.493c215e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/fig_6b.jpg
// module id = 678
// module chunks = 0